import React from 'react'
import styles from './styles.module.css'

interface FooterProps {
  children: React.ReactNode
}

export const Footer = ({ children }: FooterProps) => {
  return <div className={styles.buttonWrapper}>{children}</div>
}
